module.exports = __webpack_public_path__ + "static/media/user-menu-icon.1c8fe601.svg";